import { Price } from '../Price.es.js';

/** @module Classes */ /** typedoc */
class ReleaseBalance extends Price {
    constructor() {
        super(...arguments);
        this.totalAmountReceived = null;
    }
}

export { ReleaseBalance };
